/**
 * @file de-error.ts - German error codes translation.
 * @author st,hs
 * @copyright Copyright KNE GmbH. All Rights Reserved.
 *
 *
 */

/**
 * German error locale object.
 */
export const errorLocale = {
  lang: 'de',
  data: {
    'ERROR': {
       '0': 'Kein Fehler!',
       '1': 'Unbekannter Fehler. Bitte kontaktieren Sie Ihren Administrator.',
       '10': 'Der Admin account kann nicht gelöscht werden.',
       '11': 'Der Benutzer name ist schon mit einem anderen benutzer verbunden.',
       '12': 'Ein gelöschter Benutzer besitzt diesen Namen schon.',
       '13': 'Dieser Umgebungsname existiert schon.',
       '14': 'Das angeforderte Environment konnte nicht gefunden werden.',
       '15': 'Für diese Umgebung sind noch Produkte freigegeben.',
       '2': 'Falscher Benutzername oder Passwort.',
       '3': 'Benutzer nicht gefunden.',
       '4': 'Produkt nicht gefunden.',
       '5': 'Version nicht gefunden.',
       '6': 'Patch nicht gefunden',
       '7': 'Falsche Patch Signatur.',
       '8': 'Patch Datei existiert bereits',
       '9': 'Der Version sind noch Patches zugeteilt, bitte löschen Sie diese vorher.'
    }
  }
};
